{
  "Earlier": "FRÜHER",
  "newNotification": "{newCount} neue Benachrichtigung",
  "newNotifications": "{newCount} neue Benachrichtigungen",
  "noNotifications": "Sie erhalten wichtige Informationen zu Ihren Produkten, zu Ihrer Zusammenarbeit mit anderen Benutzern und sonstige wichtige Aktualisierungen.",
  "noNotificationsTitle": "Ihre Benachrichtigungen werden hier angezeigt"
}
